import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { getSimilarApplicants } from '../../../providers/api/applicant/applicantProvider';
import { Applicant } from '../../../providers/api/dtos';

export const SIMILAR_APPLICANTS_RID = '/v1/applicants/:id/similar';

export function useSimilarApplicants(applicantId?: number, options?: SWRConfiguration<Applicant[], AxiosError>): SWRResponse<Applicant[], AxiosError> {
  return useSWR(applicantId ? [SIMILAR_APPLICANTS_RID, applicantId] : null, () => getSimilarApplicants(applicantId!), options);
}
